import axios from 'axios'
import { declareAction, declareAtom } from '@reatom/core'
import * as common from '@bfg/common'
import { AppConfigAtom } from '@bfg/atoms/AppConfig'

// ======================================================================================================
export const LoadBillingReceipts = declareAction('loadBillingReceipts')

export const BillingReceipts = declareAction(
  'billingReceipts',
  (payload, store) => {
    const appState = store.getState(AppConfigAtom)
    axios.get(`${common.api}/stripe/billing-receipts/${appState.fingerprint}`)
      .then(res => {
        window.location.href = res.data.portal_url
        // store.dispatch(LoadBillingReceipts(res.data))
      })
      .catch(console.error)
  }
)

export const BillingReceiptsAtom = declareAtom(
  'billingReceiptsAtom',
  {
    url: '',
  },
  on => [
    on(LoadBillingReceipts, (state, payload) => {
      return { ...state, url: payload }
    })]
)

// ======================================================================================================
